import angular from 'angular';
import ArrayUtilService from './array.util.service';
import DateUtilService from './date.util.service';
import ObjectUtilService from './object.util.service';
import UrlUtilService from './url.util.service';

const utilModule = angular.module('app.util', ['appSettingsModule']);

utilModule
  .service('arrayUtil', ArrayUtilService)
  .service('dateUtil', DateUtilService)
  .service('objectUtil', ObjectUtilService)
  .service('urlUtil', UrlUtilService);

export default utilModule.name;
